module.exports = __webpack_public_path__ + "img/profile-white.e0a33fe3.svg";